/* Swift Pro site behaviour: robust scroll reveals + count-ups (progressive enh.). */
(function () {
  var doc = document;
  function revealAll(){doc.querySelectorAll('.cx-reveal').forEach(function(e){e.classList.add('cx-in');});}
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  function setupReveals(){
    var els = doc.querySelectorAll('.cx-reveal'); if(!els.length) return;
    if(reduce || !('IntersectionObserver' in window)){return;}
    doc.documentElement.classList.add('cx-anim');
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('cx-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -4% 0px'});
    els.forEach(function(el,i){el.style.transitionDelay=(Math.min(i,6)*.06)+'s';io.observe(el);});
    setTimeout(revealAll,1000);
    window.addEventListener('load',function(){setTimeout(revealAll,250);});
  }
  function setupCounts(){
    doc.querySelectorAll('[data-cxh-count]').forEach(function(el){
      var target=parseFloat(el.getAttribute('data-cxh-count'));
      var suf=el.getAttribute('data-suffix')||'',pre=el.getAttribute('data-prefix')||'';
      var dec=(target%1!==0)?1:0,started=false;
      function run(){if(started)return;started=true;var s=null;
        function step(ts){if(!s)s=ts;var p=Math.min((ts-s)/1200,1);var v=target*(1-Math.pow(1-p,3));
          el.innerHTML=pre+v.toFixed(dec)+suf;if(p<1)requestAnimationFrame(step);}requestAnimationFrame(step);}
      if(!('IntersectionObserver' in window)){el.innerHTML=pre+target.toFixed(dec)+suf;return;}
      var o=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)run();});},{threshold:.5});
      o.observe(el);setTimeout(run,1400);
    });
  }
  function init(){setupReveals();setupCounts();}
  if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',init);else init();
})();
